import { BaseSyntheticEvent } from 'react';
import { triggerLinkFollowedEvent } from '../../engineClient/actions/eventActions';

interface DetailsWidgetProps {
  body?: string | JSX.Element;
  heading: string;
  eventKey?: string;
  className?: string;
}

export function DetailsWidget({ body, heading, eventKey, className = 'hp-details' }: DetailsWidgetProps): JSX.Element {
  const onClick = (event: BaseSyntheticEvent): void => {
    const link: Partial<HTMLAnchorElement> = { href: eventKey, name: heading };
    triggerLinkFollowedEvent({ getEvent: () => event, link: link as HTMLAnchorElement });
  };

  return (
    <details className={className}>
      {body}
      <summary onClick={onClick}>{heading}</summary>
    </details>
  );
}
